import { CSSProperties, ReactNode } from 'react';
import { PlacesType, Tooltip } from 'react-tooltip';

interface IDropDown {
  id: string;
  className?: string;
  offset?: number;
  position: PlacesType;
  arrow?: boolean;
  onClick?: boolean;
  children: ReactNode;
  afterHide?: (status: boolean) => void;
  afterShow?: () => void;
  style?: CSSProperties;
  isOpen?: boolean;
}

const DropDown: React.FC<IDropDown> = ({
  id,
  offset = 0,
  position,
  arrow = false,
  onClick = false,
  children,
  afterHide,
  afterShow,
  style,
  isOpen,
  className
}) => {
  const styles: CSSProperties = {
    borderRadius: 8,
    ...style,
  };

  return (
    <Tooltip
      clickable
      id={id}
      place={position}
      offset={offset}
      openOnClick={onClick}
      noArrow={arrow}
      afterHide={() => (afterHide ? afterHide(false) : {})}
      closeEvents={{ click: onClick, mouseleave: onClick ? false : true }}
      isOpen={isOpen}
      className={`tooltip shadow-level-4 sm:w-32 ${className}`}
      classNameArrow='tooltip-arrow'
      opacity={1}
      style={styles}
      afterShow={afterShow}
    >
      {children}
    </Tooltip>
  );
};

export default DropDown;
